const apiHost = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/$/, '');
const publicApiKey = process.env.REACT_APP_PUBLIC_API_KEY || '';

export const API_CONFIG = {
  // When REACT_APP_API_BASE_URL is set (e.g. http://localhost:3000), call reckoning-backend directly.
  BASE_URL: apiHost ? `${apiHost}/api` : '/api',
  PUBLIC_API_KEY: publicApiKey,
  ENDPOINTS: {
    TOKEN: '/token',
    RECORDS: '/records',
    AGGREGATE: '/records/aggregate',
    SUBMIT_CASE: '/cases/submit',
    SUBMIT_SOURCE: '/public-source-submissions',
    PUBLIC: {
      MAP_GAZETTEER: '/public/map/gazetteer',
      MAP_GAZETTEER_STATES: '/public/map/gazetteer/states',
    },
  },
};